import axios from "axios";

import { aiBaseURL, assessmaxBaseurl, refresh } from "../settings/apiConfig";
import { ACCESS_TOKEN } from "../settings/auth";
import { getValue } from "../settings/token";

const getHeaders = (auth, data, token) => {
    const headers = {
        'Content-Type': 'application/json'
    }
    
    if ( auth  ) {

        if ( token ) {
            headers['Authorization'] = 'Bearer ' + token;
        }else {
            const bearerToken = getValue(ACCESS_TOKEN);
            
            if ( bearerToken ) {
                headers['Authorization'] = 'Bearer ' + bearerToken;
            }
        }
    }

    const config = { headers };
    
    if ( data ) {
        config['data'] = data;
    }

    return config;
};

export const getApi = (url, auth=true, token=null) => {
    return axios.get(assessmaxBaseurl + url, getHeaders(auth, null, token));
};

export const postApi = (url, data, auth=true, token=null) => {
    return axios.post(assessmaxBaseurl + url, data, getHeaders(auth, null, token));
};

export const putApi = (url, data, auth=true, token=null) => {
    return axios.put(assessmaxBaseurl + url, data, getHeaders(auth, null, token));
};

export const deleteApi = (url, data, auth=true) => {
    return axios.delete(assessmaxBaseurl + url, getHeaders(auth, data));
};

export const refreshApi = (data, token) => {
    return axios.post(assessmaxBaseurl + refresh, data, getHeaders(true, null, token));
};